"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBList = exports.DBItem = void 0;
var react_1 = __importStar(require("react"));
var auth_1 = require("react-firebase-hooks/auth");
var __1 = require("../../../");
var DBItem = function (_a) {
    var path = _a.path, Component = _a.Component, noAuth = _a.noAuth, log = _a.log, data = _a.data;
    var logic = (0, __1.useEloise)().logic;
    var _b = (0, react_1.useState)(data), value = _b[0], setValue = _b[1];
    var update = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var test, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!noAuth) return [3 /*break*/, 2];
                    return [4 /*yield*/, logic.fb.docs.setDoc(path, data)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, logic.fb.docs.setUserDoc(path, data)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    test = _a;
                    if (test) {
                        return [2 /*return*/, data];
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null, value && (react_1.default.createElement(Component, { data: value, update: update }))));
};
exports.DBItem = DBItem;
var DBList = function (_a) {
    var path = _a.path, Component = _a.Component, Empty = _a.Empty, filter = _a.filter, noAuth = _a.noAuth, log = _a.log;
    var _b = (0, __1.useEloise)(), theme = _b.theme, logic = _b.logic, siteConfig = _b.siteConfig;
    var _c = (0, auth_1.useAuthState)(logic.fb.auth), user = _c[0], loading = _c[1], error = _c[2];
    var _d = (0, react_1.useState)(), docs = _d[0], setDocs = _d[1];
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var test_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!user) return [3 /*break*/, 5];
                    if (!noAuth) return [3 /*break*/, 2];
                    return [4 /*yield*/, logic.fb.docs.getCollection(path)];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, logic.fb.docs.getUserCollection(path)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    test_1 = _a;
                    log && console.log(test_1);
                    setDocs(test_1);
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [user]);
    if (!docs) {
        return react_1.default.createElement(__1.Loading, null);
    }
    // If a filter function is provided, use it to filter the documents
    var filteredDocs = filter ? docs.filter(filter) : docs;
    if (filteredDocs && filteredDocs.length === 0 && Empty) {
        return react_1.default.createElement(Empty, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, filteredDocs.map(function (value) { return (react_1.default.createElement(exports.DBItem, { log: log, key: value.id, Component: Component, data: value.data, path: "".concat(path, "/").concat(value.id) })); })));
};
exports.DBList = DBList;
